import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AdminGuard implements CanActivate {
  constructor(public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
   //  Guard for user is login or not
    //let user = JSON.parse(localStorage.getItem("user"));

    let user = JSON.parse(localStorage.getItem("user"));
    if (!user || user === null) {
      localStorage.clear();
      localStorage.setItem("redirectUrl", state.url);
      this.router.navigate(["/authentication/login"]);
      return true;
    }


    return true;
  }
}
